import { render, staticRenderFns } from "./AdvertisingContribution.vue?vue&type=template&id=1b050003&"
import script from "./AdvertisingContribution.vue?vue&type=script&lang=js&"
export * from "./AdvertisingContribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports